export default __webpack_public_path__ + "static/media/Slide27.354956b7.JPG";